import * as Ariakit from '@ariakit/react';
import styled, { css } from 'styled-components';
import { easeInOutCubic, fromMd, timingFast, timingFaster, zIndexModal } from '../../constants';
import { SelectMark } from '../Icons';
export const Backdrop = styled.div `
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: ${zIndexModal - 1};
  opacity: 0;
  transition: ${timingFaster} ${easeInOutCubic} opacity;
  &[data-enter] {
    opacity: 1;
  }
`;
export const Header = styled.div `
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-direction: ${o => (o.$reverse === true ? 'row-reverse' : 'row')};
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: ${o => o.theme.spacing(4, 0)};
  margin: ${o => o.theme.spacing(0, 4)};

  ${fromMd} {
    padding: ${o => o.theme.spacing(6, 0)};
    margin: ${o => o.theme.spacing(0, 10)};
  }

  ${o => o.$borderless === false &&
    css `
      border-bottom: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
    `}
`;
export const deprecatedHeaderSpacing = css `
  padding: ${o => o.theme.spacing(4)};
  margin: 0;

  ${fromMd} {
    padding: ${o => o.theme.spacing(6, 10)};
    margin: 0;
  }
`;
export const Title = styled(Ariakit.DialogHeading) `
  flex-grow: 1;
  flex-basis: 100%;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: ${o => o.$align === 'center' ? 'center' : o.$align === 'right' ? 'flex-end' : 'flex-start'};
  gap: ${o => o.theme.spacing(2)};
`;
export const Content = styled.div `
  position: relative;
  flex-grow: 1;
  flex-shrink: 0;
  padding: ${o => o.theme.spacing(6, 4)};

  ${fromMd} {
    padding: ${o => o.theme.spacing(6, 10)};
  }
`;
export const CloseIconButton = styled.button `
  padding: ${o => o.theme.spacing(1)};
  transition: ${timingFast} ${easeInOutCubic} opacity;
  &:hover {
    opacity: 0.5;
  }
`;
export const Dismiss = styled(Ariakit.DialogDismiss) ``;
export const CloseIcon = styled(SelectMark) `
  display: block;
`;
export const Footer = styled.div `
  flex-grow: 0;
  flex-shrink: 0;
  border-top: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  padding: ${o => o.theme.spacing(4)};
`;
//# sourceMappingURL=styles.js.map